module.exports = __webpack_public_path__ + "static/email-marketing-14688332d8e16e122c8d26580e02d493.png";